import { Injectable } from '@angular/core';
import { IonicSafeString, ToastController, AlertController } from '@ionic/angular/standalone';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  //#region Constructor

  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private util: UtilService
  ) { }

  //#endregion

  //#region Diálogos

  public showMessage(msg: string | IonicSafeString, title?: string, textoOk?: string): Promise<void> {
    return new Promise<void>(async resolve => {
      const alert = await this.alertCtrl.create({
        header: title || 'Ingein',
        message: msg,
        buttons: [textoOk || 'OK']
      })
      await alert.present()
      alert.onDidDismiss().then(() => {
        resolve()
      })
    })
  }

  public showConfirm(msg: string | IonicSafeString, title?: string, textoOk?: string, textoCancel?: string, classOk?: string, classCancel?: string, classAlerta?: string): Promise<boolean> {
    return new Promise<boolean>(async resolve => {
      const alert = await this.alertCtrl.create({
        header: title || 'Ingein',
        message: msg,
        cssClass: classAlerta,
        buttons: [
          {
            text: textoCancel || 'No',
            role: 'cancel',
            cssClass: classCancel
          },
          {
            text: textoOk || 'Sí',
            role: 'confirm',
            cssClass: classOk
          }
        ]
      })
      await alert.present()
      alert.onDidDismiss().then(value => {
        resolve(value?.role == 'confirm')
      })
    })
  }

  public showPrompt(msg: string | IonicSafeString, title?: string, placeholder?: string, textoOk?: string, textoCancel?: string, defaultValue?: string, textarea?: boolean, inputType?: 'text' | 'password'): Promise<string> {
    return new Promise<string>(async resolve => {
      const alert = await this.alertCtrl.create({
        header: title || 'Ingein',
        message: msg,
        buttons: [
          {
            text: textoCancel || 'Cancelar',
            role: 'cancel'
          },
          {
            text: textoOk || 'Aceptar',
            role: 'confirm'
          }
        ],
        inputs: [
          {
            name: 'inputEl',
            type: textarea ? 'textarea' : (inputType || 'text'),
            placeholder: placeholder || '',
            value: defaultValue || '',
            cssClass: 'prompt-input'
          }
        ]
      })
      alert.present().then(async () => {
        await this.util.Sleep(300)
        let inputEl = alert.querySelector('.prompt-input') as HTMLInputElement
        inputEl.focus()
      })
      
      alert.onDidDismiss().then(value => {
        if (value?.role == 'confirm') {
          resolve(value.data.values.inputEl as string)
        } else{
          resolve(null)
        }
      })
    })
  }

  public showToast(msg: string | IonicSafeString, duration?: number): Promise<void> {
    return new Promise<void>(async resolve => {
      const toast = await this.toastCtrl.create({
        message: msg,
        duration: duration || 3000,
        position: 'top'
      })
      await toast.present()
      toast.onDidDismiss().then(() => {
        resolve()
      })
    })
  }

  //#endregion

}
